module.exports = __webpack_public_path__ + "f051fb6b8ec6837f2b1d3557dfb71af0.svg";